import React, { useEffect, useState } from 'react';

import './BubbleProgress.scss';

interface BubbleProgressPropsBase {
  duration?: number;
  onFinish?: () => void;
}

type BubbleProgressProps = React.HTMLAttributes<HTMLDivElement> & BubbleProgressPropsBase;

export default function BubbleProgress(props: BubbleProgressProps) {
  const {
    // from component
    onFinish,
    duration: propDuration,
    // from element
    className: propClasses,
    ...rest
  } = props;
  const [tick, setTick] = useState(0);
  const [progress, setProgress] = useState(0);

  const duration = propDuration || 60;

  useEffect(() => {
    const t = setInterval(() => {
      setTick(tck => (tck < 0 ? tck : tck + 1));
    }, 1000);

    return () => {
      clearInterval(t);
      setTick(0);
      setProgress(0);
    };
  }, []);

  useEffect(() => {
    if (tick < 0) return;

    const newProgress = Math.min(
      100,
      100 - Math.ceil((100 * Math.abs(tick - duration)) / duration)
    );

    setProgress(newProgress);
  }, [tick]);

  useEffect(() => {
    if (progress === 100) {
      setTick(-1);
      if (onFinish) onFinish();
    }
  }, [progress]);

  const classes = ['bubble-progress'];
  if (propClasses) classes.push(propClasses);

  return (
    <div {...rest} className={classes.join(' ')}>
      <div className="progress-indicator" style={{ width: `${progress}%` }} />
    </div>
  );
}
